export default __webpack_public_path__ + "static/media/valid.8e11ff79.png";